import { render } from "./poll_form.vue?vue&type=template&id=5dd9a9d1"
import script from "./poll_form.js?vue&type=script&lang=js"
export * from "./poll_form.js?vue&type=script&lang=js"

import "./poll_form.vue?vue&type=style&index=0&id=5dd9a9d1&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__